import * as React from 'react'
import PropTypes from 'prop-types'
import { Container, Section } from 'chaoskit/src/components'

const Segment = React.forwardRef(
  ({ space = 'base', children, ...rest }, ref) => (
    <Section
      className="SOCE__Section"
      ref={ref}
      space={space}
      css={{ overflow: 'hidden' }}
      {...rest}
    >
      <Container>{children}</Container>
    </Section>
  )
)

Segment.propTypes = {
  children: PropTypes.node.isRequired,
  space: PropTypes.string,
}

export default Segment
